import * as React from 'react';

import { getCurrentUser } from '../api/userSettings';

/**
 * Cached across callers: the sidebar, the Messages page and the dashboard card
 * all need this answer on the same render, and it never changes mid-session.
 *
 * Redux `userAuth.info` is stamped at login, so it would go stale the moment a
 * Super Admin designates a different sender. This reads the user fresh instead.
 *
 * No invalidation hook: logout reloads the page, which drops this module.
 */
let pending: Promise<boolean> | null = null;

const load = () => {
  if (!pending) {
    pending = getCurrentUser(undefined)
      .then(response =>
        Boolean(response.data?.canSendInspectorMotd))
      .catch(() => false);
  }
  return pending;
};

/**
 * True only for the single inspector a Super Admin designated in
 * Settings > Message Setup. The backend enforces the same rule on every write,
 * so this is presentation only, not access control.
 */
const useCanSendInspectorMotd = () => {
  const [canSend, setCanSend] = React.useState(false);
  const [isChecked, setIsChecked] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;

    load().then(allowed => {
      if (cancelled) return;
      setCanSend(allowed);
      setIsChecked(true);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return { canSend, isChecked };
};

export default useCanSendInspectorMotd;
